/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DmvsR17PotvrdZapracovatelnostRequest } from '../types/DmvsR17PotvrdZapracovatelnost';
import type { DmvsR17PotvrdZapracovatelnostResponse } from '../types/DmvsR17PotvrdZapracovatelnost';

export type SvuCrossOwnerDocsR17PotvrdZapracovatelnostCreateRequest =
  DmvsR17PotvrdZapracovatelnostRequest;
export type SvuCrossOwnerDocsR17PotvrdZapracovatelnostCreateResponse =
  DmvsR17PotvrdZapracovatelnostResponse;

export type SvuCrossOwnerDocsR17PotvrdZapracovatelnostCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/r17_potvrd_zapracovatelnost/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_r17_potvrd_zapracovatelnost_create
 * tags:
 *   - svu_cross_owner_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     description: ''
 * ```
 */
export const svuCrossOwnerDocsR17PotvrdZapracovatelnostCreateOperation = ({
  id,
  ...rest
}: SvuCrossOwnerDocsR17PotvrdZapracovatelnostCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/svu_cross_owner_docs/${id}/r17_potvrd_zapracovatelnost/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & {
      _templateUrl: '/dmx-server/svu_cross_owner_docs/{id}/r17_potvrd_zapracovatelnost/';
    };
  };

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/r17_potvrd_zapracovatelnost/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_r17_potvrd_zapracovatelnost_create
 * tags:
 *   - svu_cross_owner_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsR17PotvrdZapracovatelnost'
 *     description: ''
 * ```
 */
export const svuCrossOwnerDocsR17PotvrdZapracovatelnostCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuCrossOwnerDocsR17PotvrdZapracovatelnostCreateQuery;
  request: DmvsR17PotvrdZapracovatelnostRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DmvsR17PotvrdZapracovatelnostResponse>> => {
  const operation = svuCrossOwnerDocsR17PotvrdZapracovatelnostCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
